import React, { useContext, useEffect } from "react";
import { Container, Grid, Header } from "semantic-ui-react";
import { observer } from "mobx-react-lite";
import UserAuthStore from "../../app/stores/userauthStore";
import LiveChat from "react-livechat";
import { render } from "react-dom";
import { setgroups } from "process";

//ADD221220 - set livechat group for different client
const getLivechatGroup = (client) => {
  if(client == "Hexagon"){
    return 4;
  }else if(client == "Red Kite Housing"){
    return 2;
  }else if(client == "Inquilab"){
    return 1;
  }else{
    return 0;
  }
}



const HomePage = () => {

  const [livechatGroup,setLivechatGroup] = React.useState(5);

  let sessionObj = JSON.parse(sessionStorage.getItem("sessionObj")!);
  

   useEffect(() => {
       if(sessionObj.Client.Name == "Sovereign Network"){
        console.log("Sovereign Network")
        setLivechatGroup(5)
      } else if(sessionObj.Client.Name == "Red Kite Housing"){
        setLivechatGroup(2)
      }
    }, [sessionObj]);

  const userauthStore = useContext(UserAuthStore);
  return (
    <Container style={{ marginTop: "12em" }}>
      <Grid textAlign="center" style={{ height: "100vh" }}>
        <Grid.Column>
          <Header as="h2" textAlign="center">
            
            <h1>
              Welcome to Gilmartins Client Portal for{" "}
              {sessionObj.Client.Name}{" "}
            </h1>
          </Header>
          <p>
            Please use the navigation above to select the areas you would like
            to access
          </p>
        </Grid.Column>
      </Grid>
      <LiveChat license={12587751}/>
    </Container>
    
  );
};




export default observer(HomePage);





